import React from "react";
import CopyIcon from "../../../../icons/copy.icon";
import styles from "./index.module.scss";
import cn from "../../../../../Utils/class-names.utils";
import CircleCheckTransparentIcon from "../../../../icons/circle-check-transparent.icon";

interface ResetPasswordSuccessContentProps {
  temporaryPassword: string;
  onCopyPassword: () => void;
  onTemporaryPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ResetPasswordSuccessContent = ({
  temporaryPassword,
  onCopyPassword,
  onTemporaryPasswordChange,
}: ResetPasswordSuccessContentProps) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.successAlert}
        role="alert"
        aria-live="polite"
      >
        <div className={styles.iconWrapper}>
          <CircleCheckTransparentIcon checked={true} width={18} height={18} />
        </div>

        <div className={styles.messageWrapper}>
          <p className={styles.messageText}>
            User&apos;s password updated with temporary password
          </p>
        </div>
      </div>

      <div className={styles.passwordContainer}>
        <div className={styles.formWrapper}>
          <label
            htmlFor="temporary-password"
            className={styles.label}
          >
            Temporary password:
          </label>

          <div className={styles.inputContainer}>
            <div className={styles.inputWrapper}>
              <input
                id="temporary-password"
                type="text"
                value={temporaryPassword}
                className={styles.input}
                aria-label="Temporary password"
                onChange={onTemporaryPasswordChange}
              />
            </div>

            <button
              onClick={onCopyPassword}
              className={cn(styles.copyButton, "my-button")}
              type="button"
            >
              <div className={styles.copyIconWrapper}>
                <CopyIcon />
              </div>
            </button>
          </div>

          <p className={styles.helpText}>
            User will be required to set a new password as soon as they log in
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordSuccessContent;

